/**
 * Capitalize the first letter of a string
 * @param string the string to modify
 */
export const capitalizeFirstLetter = (string: string) => string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();